/**
 * @generated SignedSource<<b99989ceaaec5ef5e5f4ae751d1b4cd2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalEmbedQuery$variables = {
  id: string;
  isSpecificUpdate: boolean;
  key: string;
};
export type GoalEmbedQuery$data = {
  readonly goalByKey?: {
    readonly id: string;
    readonly updates: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"GoalEmbedUpdate">;
        } | null;
      } | null> | null;
    } | null;
    readonly workspace: {
      readonly uuid: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"GoalEmbedAbout" | "GoalEmbedRow">;
  } | null;
  readonly goalUpdate?: {
    readonly goal: {
      readonly id: string;
      readonly workspace: {
        readonly uuid: string;
      };
      readonly " $fragmentSpreads": FragmentRefs<"GoalEmbedAbout" | "GoalEmbedRow">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"GoalEmbedUpdate">;
  } | null;
};
export type GoalEmbedQuery = {
  response: GoalEmbedQuery$data;
  variables: GoalEmbedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSpecificUpdate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v3 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  }
],
v4 = {
  "kind": "FragmentSpread",
  "name": "GoalEmbedAbout"
},
v5 = {
  "kind": "FragmentSpread",
  "name": "GoalEmbedRow"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v8 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v7/*: any*/)
  ]
},
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v10 = {
  "kind": "FragmentSpread",
  "name": "GoalEmbedUpdate"
},
v11 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "key"
},
v13 = {
  "kind": "ScalarField",
  "name": "ari"
},
v14 = {
  "kind": "ScalarField",
  "name": "name"
},
v15 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        {
          "kind": "ScalarField",
          "name": "picture"
        },
        {
          "kind": "ScalarField",
          "name": "accountStatus"
        },
        {
          "kind": "ScalarField",
          "name": "accountId"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "aaid"
    },
    (v6/*: any*/)
  ]
},
v16 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v6/*: any*/)
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "description"
},
v18 = {
  "kind": "ScalarField",
  "name": "descriptionWhy"
},
v19 = {
  "kind": "ScalarField",
  "name": "descriptionMeasurement"
},
v20 = {
  "concreteType": "GoalIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    {
      "kind": "ScalarField",
      "name": "appearance"
    }
  ]
},
v21 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v22 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v23 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v22/*: any*/)
},
v24 = {
  "kind": "ScalarField",
  "name": "score"
},
v25 = {
  "kind": "ScalarField",
  "name": "value"
},
v26 = {
  "concreteType": "GoalState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    (v23/*: any*/),
    (v24/*: any*/),
    (v25/*: any*/),
    {
      "concreteType": "CompletionGoalState",
      "kind": "LinkedField",
      "name": "atCompletionState",
      "plural": false,
      "selections": [
        (v21/*: any*/),
        (v23/*: any*/),
        (v25/*: any*/),
        (v24/*: any*/)
      ]
    }
  ]
},
v27 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v28 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "confidence"
    },
    {
      "kind": "ScalarField",
      "name": "label"
    },
    (v23/*: any*/),
    {
      "alias": "tooltip",
      "args": (v27/*: any*/),
      "kind": "ScalarField",
      "name": "label",
      "storageKey": "label(longFormat:true)"
    },
    {
      "alias": "localizedTooltip",
      "args": (v27/*: any*/),
      "concreteType": "LocalizationField",
      "kind": "LinkedField",
      "name": "localizedLabel",
      "plural": false,
      "selections": (v22/*: any*/),
      "storageKey": "localizedLabel(longFormat:true)"
    },
    {
      "kind": "ScalarField",
      "name": "overdue"
    }
  ]
},
v29 = {
  "kind": "ScalarField",
  "name": "hasSubgoalMatches"
},
v30 = {
  "concreteType": "GoalConnection",
  "kind": "LinkedField",
  "name": "subGoals",
  "plural": false,
  "selections": [
    {
      "concreteType": "GoalEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    }
  ]
},
v31 = {
  "kind": "ScalarField",
  "name": "summary"
},
v32 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v33 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v34 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v35 = {
  "kind": "ScalarField",
  "name": "canPostUpdate"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalEmbedQuery",
    "selections": [
      {
        "condition": "isSpecificUpdate",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "Goal",
            "kind": "LinkedField",
            "name": "goalByKey",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              {
                "args": (v9/*: any*/),
                "concreteType": "GoalUpdateConnection",
                "kind": "LinkedField",
                "name": "updates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GoalUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "updates(first:1)"
              }
            ]
          }
        ]
      },
      {
        "condition": "isSpecificUpdate",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v11/*: any*/),
            "concreteType": "GoalUpdate",
            "kind": "LinkedField",
            "name": "goalUpdate",
            "plural": false,
            "selections": [
              {
                "concreteType": "Goal",
                "kind": "LinkedField",
                "name": "goal",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v8/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              },
              (v10/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalEmbedQuery",
    "selections": [
      {
        "condition": "isSpecificUpdate",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "Goal",
            "kind": "LinkedField",
            "name": "goalByKey",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v15/*: any*/),
              (v7/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v6/*: any*/),
              (v20/*: any*/),
              (v14/*: any*/),
              (v26/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              {
                "args": (v9/*: any*/),
                "concreteType": "GoalUpdateConnection",
                "kind": "LinkedField",
                "name": "updates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GoalUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          {
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v7/*: any*/),
                              (v13/*: any*/),
                              (v35/*: any*/),
                              (v6/*: any*/)
                            ]
                          },
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "updates(first:1)"
              }
            ]
          }
        ]
      },
      {
        "condition": "isSpecificUpdate",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v11/*: any*/),
            "concreteType": "GoalUpdate",
            "kind": "LinkedField",
            "name": "goalUpdate",
            "plural": false,
            "selections": [
              {
                "concreteType": "Goal",
                "kind": "LinkedField",
                "name": "goal",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v16/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v15/*: any*/),
                  (v7/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v14/*: any*/),
                  (v26/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v35/*: any*/)
                ]
              },
              (v7/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "bba67c6e0bffb6d938923344faac3bae",
    "id": null,
    "metadata": {},
    "name": "GoalEmbedQuery",
    "operationKind": "query",
    "text": "query GoalEmbedQuery(\n  $key: String!\n  $id: ID!\n  $isSpecificUpdate: Boolean!\n) {\n  goalByKey(key: $key) @skip(if: $isSpecificUpdate) {\n    ...GoalEmbedAbout\n    ...GoalEmbedRow\n    id\n    workspace {\n      uuid\n      id\n    }\n    updates(first: 1) {\n      edges {\n        node {\n          ...GoalEmbedUpdate\n          id\n        }\n      }\n    }\n  }\n  goalUpdate(id: $id) @include(if: $isSpecificUpdate) {\n    goal {\n      id\n      workspace {\n        uuid\n        id\n      }\n      ...GoalEmbedAbout\n      ...GoalEmbedRow\n    }\n    ...GoalEmbedUpdate\n    id\n  }\n}\n\nfragment GoalEmbedAbout on Goal {\n  key\n  ari\n  owner {\n    pii {\n      name\n    }\n    aaid\n    id\n  }\n  uuid\n  workspace {\n    uuid\n    id\n  }\n  description\n  descriptionWhy\n  descriptionMeasurement\n}\n\nfragment GoalEmbedRow on Goal {\n  ...GoalName\n  id\n  owner {\n    ...UserAvatar_1cDMtx\n    id\n  }\n  state {\n    ...GoalState\n  }\n  dueDate {\n    ...TargetDate\n  }\n  hasSubgoalMatches\n  subGoals {\n    edges {\n      __typename\n    }\n  }\n}\n\nfragment GoalEmbedUpdate on GoalUpdate {\n  uuid\n  summary\n  missedUpdate\n  updateType\n  creationDate\n  goal {\n    key\n    uuid\n    ari\n    canPostUpdate\n    id\n  }\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment UserAvatar_1cDMtx on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n"
  }
};
})();

(node as any).hash = "16c6be54b7ad8fa5abff7669e89394b3";

export default node;
